<div class="wrapper">
    <div class="io">
        <div class="io-label">{{this.label()}}</div>
        @for (io of ios(); track $index) {
            @let label = this.kanaalLabel(io);
            <kanaal-assignement [cell]="[io]" [isSelected]="false" [label]="label"
                    style="display: contents;"></kanaal-assignement>

        }
    </div>

</div>
